/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./packetVisualizations.vue?vue&type=template&id=1938db96&scoped=true"
import script from "./packetVisualizations.vue?vue&type=script&lang=js"
export * from "./packetVisualizations.vue?vue&type=script&lang=js"
import style0 from "./packetVisualizations.vue?vue&type=style&index=0&id=1938db96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938db96",
  null
  
)

export default component.exports